import axios from "infra/http";
import { useQuery } from "react-query";
import { FindContasByCategoriaResponse, FindContasByCategoriaQueryParams } from "../typings";

function useListarContaCategoria(id: string | undefined, params?: FindContasByCategoriaQueryParams) {
  return useQuery(
    [`v1/categoria-financeira/${id}/contas`, params],
    async () => {
      const { data } = await axios.get<FindContasByCategoriaResponse>(
        `v1/categoria-financeira/${id}/contas`,
        {
          params,
        }
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useListarContaCategoria;
